import Button from "components/atoms/Button";
import useTranslate from "hooks/useTranslate";

import "./styles.sass";

type CoinStrikeContentProps = {
  onClick: () => void;
};

const CoinStrikeLandingContent = (props: CoinStrikeContentProps) => {
  const { onClick: handleClick } = props;
  const t = useTranslate();

  return (
    <div className="CoinStrikeLandingContent">
      <div className="CoinStrikeLandingContent__logo" />

      <div className="CoinStrikeLandingContent__text">
        {t("landing.coinStrike.promoText")}
      </div>

      <Button
        variation="orange"
        label="info.promo.welcome.button"
        className="CoinStrikeLandingContent__button"
        onClick={handleClick}
      />
    </div>
  );
};

export default CoinStrikeLandingContent;
